import { Container, Stack, Text, Title } from '@mantine/core';
import React from 'react';
import { Breadcrumb } from '../../components/common/Breadcrumb';
import { EmployeeDictionaryManagement } from '../../features/employee-hub';
import { EmployeeDictionaryType } from '../../models/employeeHub';

export const OperationsProjectsManagement: React.FC = () => {
    return (
        <Container size="xl" py="xl">
            <Stack gap="xl">
                <div>
                    <Breadcrumb
                        items={[
                            { label: 'Operations Panel', href: '/operations' },
                            { label: 'Employee', href: '/operations/employee-hub' },
                            { label: 'Projects', isActive: true },
                        ]}
                    />
                    <Title order={1} size="h2" fw={700}>
                        Projects
                    </Title>
                    <Text c="dimmed" size="lg">
                        Manage project codes and display names
                    </Text>
                </div>

                <EmployeeDictionaryManagement
                    type={EmployeeDictionaryType.Project}
                    title="Projects"
                    searchPlaceholder="Search projects..."
                />
            </Stack>
        </Container>
    );
};
